{
  "name": "bo-app",
  "version": "2.10.1-develop.0",
  "scripts": {
    "build": "./scripts/version.sh && ng build --output-hashing all",
    "install": "cp ./package.json ./src/assets",
    "lint": "ng lint",
    "ng": "ng",
    "start": "ng serve --ssl --host localhost.sparbanken.me",
    "style-lint": "stylelint  \"src/**/*.scss\" --fix",
    "test": "ng test --watch=false --coverage",
    "watch": "ng test"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^22.0.3",
    "@angular/cdk": "^22.0.2",
    "@angular/common": "^22.0.3",
    "@angular/compiler": "^22.0.3",
    "@angular/core": "^22.0.3",
    "@angular/forms": "^22.0.3",
    "@angular/material": "^22.0.2",
    "@angular/platform-browser": "^22.0.3",
    "@angular/platform-browser-dynamic": "^22.0.3",
    "@angular/router": "^22.0.3",
    "rxjs": "^7.8.1",
    "tslib": "^2.4.0"
  },
  "devDependencies": {
    "@angular/build": "^22.0.4",
    "@angular/cli": "^22.0.4",
    "@angular/compiler-cli": "^22.0.3",
    "@angular/material-luxon-adapter": "^22.0.2",
    "@sparbanken-syd/auth-backend": "^2.6.4",
    "@sparbanken-syd/borgo-helpers": "^22.0.0",
    "@sparbanken-syd/borgo-types": "^1.0.5",
    "@sparbanken-syd/personnummer": "^3.0.1",
    "@sparbanken-syd/sparbanken-syd-bankid": "^22.0.0",
    "@sparbanken-syd/sparbanken-syd-qr": "^22.0.0",
    "@sparbanken-syd/sparbanken-syd-theme": "^22.0.1",
    "@sparbanken-syd/sparbanken-syd-theme-m3": "^22.0.0",
    "@sparbanken-syd/spb-file-mgmt": "^1.4.0",
    "@types/jmespath": "^0",
    "@types/luxon": "^3.4.2",
    "@types/node": "24",
    "@typescript-eslint/eslint-plugin": "^8.33.1",
    "@typescript-eslint/parser": "^8.33.1",
    "@typescript-eslint/types": "^8.26.1",
    "@typescript-eslint/utils": "^8.33.1",
    "@vitest/coverage-v8": "^4.1.9",
    "@vitest/ui": "^4.1.9",
    "angular-eslint": "^22.0.0",
    "eslint": "^9.28.0",
    "eslint-plugin-import": "^2.31.0",
    "eslint-plugin-prefer-arrow": "^1.2.3",
    "istanbul-lib-instrument": "^6.0.3",
    "jmespath": "^0.16.0",
    "jsdom": "^29.1.1",
    "luxon": "^3.5.0",
    "postcss": "^8.5.3",
    "postcss-scss": "^4.0.9",
    "stylelint": "^16.15.0",
    "stylelint-config-standard-scss": "^16.0.0",
    "stylelint-scss": "^6.11.1",
    "typescript": "~6.0.3",
    "typescript-eslint": "^8.33.1",
    "vitest": "^4.1.9"
  },
  "closed": {
    "start": "2025-04-09T03:00:00",
    "end": "2025-04-09T09:00:00"
  }
}
